const Google = () => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.5224 12.2878C23.5224 11.4773 23.4439 10.6407 23.3132 9.85645L11.9932 9.85645V14.4838H18.4767C18.2153 15.974 17.3525 17.2811 16.0715 18.1177L19.9407 21.1242C22.2152 19.0066 23.5224 15.9217 23.5224 12.2878Z"
        fill="#4280EF"
      />
      <path
        d="M11.9932 24.0002C15.2349 24.0002 17.9538 22.9283 19.9407 21.0983L16.0715 18.1179C14.9996 18.8499 13.614 19.2682 11.9932 19.2682C8.85597 19.2682 6.2155 17.1506 5.24819 14.3271L1.27441 17.3859C3.31359 21.4381 7.44423 24.0002 11.9932 24.0002Z"
        fill="#34A353"
      />
      <path
        d="M5.24826 14.3004C4.75154 12.8102 4.75154 11.1893 5.24826 9.69917L1.27449 6.61426C-0.424828 10.0129 -0.424828 14.0128 1.27449 17.3853L5.24826 14.3004Z"
        fill="#F6B704"
      />
      <path
        d="M11.9932 4.75854C13.6925 4.73239 15.3656 5.38597 16.5944 6.56242L20.0192 3.11151C17.8493 1.07233 14.9735 -0.025687 11.9932 0.000456276C7.44423 0.000456276 3.31359 2.5625 1.27441 6.61471L5.24819 9.69962C6.2155 6.85 8.85597 4.75854 11.9932 4.75854Z"
        fill="#E54335"
      />
    </svg>
  );
};

export default Google;
